/* eslint-disable */
import React, {useState} from 'react';
import 'contents/assets/scss/page/student.scss';
import Upload from '../../../component/Inc/Upload';
import Modal from '../../../component/Inc/Modal';
import PopStudentDetail from '../../mypage/_PopStudentDetail';
function StudentDetail() {
  const [modalStudentDetail, setModalStudentDetail] = useState(false);
  const [modalPassword, setModalPassword] = useState(false);

  return (
    <main className="com_container com_member_info p_student_detail">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className="com_pg_tit icon menu1_4">
            학생관리
            <span className="bar" />
            <span className="point_txt">학생 상세 정보 (홍학생103ㆍ경기고1ㆍ남)</span>
          </h2>
        </section>
        <section className="com_pg_container">
          <section className="box full">
            <table className="com_board_list type_row">
              <colgroup>
                <col width="10%" />
                <col width="35%" />
                <col width="10%" />
                <col width="35%" />
              </colgroup>
              <tbody>
                <tr>
                  <th>이름</th>
                  <td>
                    <div className="com_input_wrap flex_row">
                      <input type="text" className="input" defaultValue={`홍길동201`} />
                    </div>
                  </td>
                  <th>학생 휴대폰</th>
                  <td>
                    <div className="com_input_wrap flex_row">
                      <input type="text" className="input" defaultValue={`010-222-2222`} />
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>학교</th>
                  <td>
                    <div className="com_input_wrap flex_row">
                      <select className="select wm2">
                        <option value="경기도">경기도</option>
                        <option value="서울">서울</option>
                      </select>
                      <select className="select wm2">
                        <option value="서울고등학교">서울고등학교</option>
                        <option value="경기고등학교">경기고등학교</option>
                      </select>
                    </div>
                  </td>
                  <th>학생 이메일</th>
                  <td className="type_row">
                    <div className="com_input_wrap">
                      <input type="text" className="input ws" />
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>생년월일 / 성별</th>
                  <td>
                    <div className="com_input_wrap flex_row gap">
                      <input type="date" className="com_datepicker" placeholder="2022. 01. 01" />
                      <div className="check">
                        <input type="radio" name="rdo" id="rdo01" className="com_chk circle" />
                        <label htmlFor="rdo01">남</label>
                        <input type="radio" name="rdo" id="rdo02" className="com_chk circle" />
                        <label htmlFor="rdo02">여</label>
                      </div>
                    </div>
                  </td>
                  <th>모 휴대폰</th>
                  <td>
                    <div className="com_input_wrap flex_row">
                      <input type="text" className="input" defaultValue={`010-222-2222`} />
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>희망대 <span className='sub'>(학과)</span></th>
                  <td>
                    <div className="com_input_wrap flex_row">
                      <input type="text" className="input" placeholder="희망대 입력" />
                      <input type="text" className="input" placeholder="희망학과 입력" />
                    </div>
                  </td>
                  <th>부 휴대폰</th>
                  <td>
                    <div className="com_input_wrap flex_row">
                      <input type="text" className="input" defaultValue={`010-222-2222`} />
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>아이디 <span className='sub'>(이지오답핏)</span></th>
                  <td>
                    <div className="com_input_wrap flex_row">
                      <input type="text" className="input" defaultValue={`dkdlel`} />
                    </div>
                  </td>
                  <th>학부모 이메일</th>
                  <td>
                    <input type="text" className="input" />
                  </td>
                </tr>
                <tr>
                  <th>비밀번호 <span className='sub'>(이지오답핏)</span></th>
                  <td>
                    <div className="com_input_wrap flex_between">
                      <div>
                        <input type="text" className="input" defaultValue={`@@1312`} />
                      </div>
                      <button onClick={() => setModalPassword(true)} className="com_btn gray s">
                        비밀 번호 변경 전송
                      </button>
                    </div>
                  </td>
                  <th rowSpan={2}>학습환경</th>
                  <td rowSpan={2} className="border_left">
                    <div className="com_input_wrap flex_row">
                      <select className="select wm2">
                        <option value="관심정도 최상">관심정도 최상</option>
                      </select>
                      <select className="select wm2">
                        <option value="지원정도 최상">지원정도 최상</option>
                      </select>
                    </div>
                    <div className="com_input_wrap flex_row">
                      <select className="select wm2">
                        <option value="가정형편 최상">가정형편 최상</option>
                      </select>
                      <select className="select wm2">
                        <option value="내신성적 최상">내신성적 최상</option>
                      </select>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>입회일</th>
                  <td>
                    <div className="com_input_wrap flex_row">
                      <input type="date" className="com_datepicker" placeholder="2022. 01. 01" />
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>입회학년</th>
                  <td>
                    <div className="com_input_wrap flex_row">
                      <select className="select wm">
                        <option value="2021">2021</option>
                      </select>
                      <select className="select wm">
                        <option value="중1">중1</option>
                      </select>
                      <select className="select wm">
                        <option value="인문">인문</option>
                      </select>
                    </div>
                  </td>
                  <th>생기부파일</th>
                  <td className="type_row">
                    <div className="com_input_wrap flex_row">
                      <div className="com_input_upload">
                        <Upload title="파일 등록" className="com_btn gray xs wl" />
                        <p className="file">
                          <span className="txt">File name.pdf</span>
                          <button type="button" className="btn_del_file" onClick={() => {}}></button>
                          <button type="button" className="btn_down" onClick={() => {}}></button>
                        </p>
                      </div>
                      <button className="com_btn xs btn_request orange btn_attatch_orange">생기부 파일 업로드링크 전송</button>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>현재 학년</th>
                  <td>
                    <div className="com_input_wrap flex_row">
                      <select className="select">
                        <option value="중2">중2</option>
                      </select>
                    </div>
                  </td>
                  <th>가상 계좌</th>
                  <td className="type_row">
                    <div className="com_input_wrap flex_row">
                      <input type="text" className="input wl" />
                      <button className="com_btn xs btn_request orange btn_msg_orange">문자 전송</button>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>현재 학년 사유</th>
                  <td>
                    <div className="com_input_wrap flex_row">
                      <select className="select">
                        <option value="유급1년">유급1년</option>
                      </select>
                    </div>
                  </td>
                  <th>환불 계좌</th>
                  <td>
                    <div className="com_input_wrap flex_row">
                      <input type="text" className="input ws" placeholder="예금주" />
                      <input type="text" className="input wl" placeholder="계좌번호" />
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>홍보문자 수신</th>
                  <td>
                    <div className="com_input_wrap flex_row">
                      <div className="check">
                        <input type="radio" name="rdo" id="rdo03" className="com_chk circle" />
                        <label htmlFor="rdo03">수신</label>
                        <input type="radio" name="rdo" id="rdo04" className="com_chk circle" />
                        <label htmlFor="rdo04">거부</label>
                      </div>
                    </div>
                  </td>
                  <th>주소</th>
                  <td>
                    <div className="com_input_wrap flex_row">
                      <input type="text" className="input wl" />
                      <button className="com_btn gray xs">우편번호</button>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>담임</th>
                  <td>
                    <section className="com_board_search end">
                      <article className="search">
                        <input type="search" placeholder="담임명 검색" className="input s type_search" />
                        <button className="com_btn gray ws s icon_search"></button>
                      </article>
                    </section>
                  </td>
                  <th>상세주소</th>
                  <td>
                    <div className="com_input_wrap flex_row">
                      <input type="text" className="input wl" />
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>특별관리회원</th>
                  <td>
                    <div className="com_input_wrap flex_row">
                      <div className="check">
                        <input type="checkbox" name="chk" id="chk01" className="com_chk" />
                        <label htmlFor="chk01" />
                      </div>
                      <input type="text" className="input wl" placeholder="사유 입력" />
                    </div>
                  </td>
                  <th>약도</th>
                  <td>
                    <div className="com_input_wrap flex_row">
                      <input type="text" className="input wl" />
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>메모</th>
                  <td colSpan={3}>
                    <div className="com_input_wrap flex_between">
                      <div className="memo">외동아들 0512 : 중간고사 88점</div>
                      <button onClick={() => setModalStudentDetail(true)} className="com_btn gray xs">
                        등록
                      </button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>

            <div className="com_btn_wrap center bottom">
              <button className="com_btn orange s">저장</button>

              <button
                onClick={() => {
                  setModalLeaveOpen(true);
                }}
                className="com_btn line gray s btn_enter"
              >
                회원 탈퇴
              </button>
            </div>
          </section>
        </section>
      </div>
      <PopStudentDetail open={modalStudentDetail} close={() => setModalStudentDetail(false)} />
      <Modal open={modalPassword} close={() => setModalPassword(false)} type="type_alert">
        <div className="content_container mb_no">
          <div className="txt">
            비밀번호가 자동 변경되고,
            <br />
            당사자에게 문자 정송됩니다.
          </div>
        </div>
        <div className="btn_container">
          <button className="com_btn lightGray xs">취소</button>
          <button className="com_btn orange xs">확인</button>
        </div>
      </Modal>
    </main>
  );
}

export default StudentDetail;
